import React,{useState} from 'react'
import { Link } from 'react-router-dom'
import logo from "../../assests/no_image.jpg"
import { FaGreaterThan } from "react-icons/fa6";


const ClientListCard = ({client}) => {

    const [imageUri,setImageUri]=useState(process.env.REACT_APP_ASSETS_URL+client?.client_logo_path)
  
  return (
    <div className="d-flex flex-column flex-xl-row p-3 m-2 gap-3 mb-0 campaign_item_card" >
    <div className="">
        {imageUri?
        <div className="bg-white p-2 h-100  client_profile_image  d-flex justify-content-center align-items-center">
            {/* <img src={client?.client_logo_path?process.env.REACT_APP_ASSETS_URL+client?.client_logo_path:logo} 
            onError={()=>{
                client.client_logo_path=null
            }}
            
            className="w-100 h-100" alt="" /> */}
             <img 
              src={imageUri?process.env.REACT_APP_ASSETS_URL+client?.client_logo_path:''} 
              onError={() => setImageUri(null)} 
              className="img-fluid rounded " 
              alt="Client Logo" 
            />
          
        </div>:
             <div className="bg-white p-2   client_profile_image  d-flex justify-content-center align-items-center">
                <div className='d-flex justify-content-center align-items-center h-100 fs-2 fw-bold'>{client?.client_name?.substring(0, 2).toUpperCase()}</div>
             </div> }


    </div>
    <div className="w-100">
        <div
            className="d-flex flex-wrap justify-content-between  my-2 pb-2  border-bottom ">
            <div className="d-flex align-items-center gap-1 ">
              
                <p className="mb-0">{client?.client_name}</p>
            </div>
            <span> </span>

        </div>
        <div className="row d-flex align-items-center mt-2">
            <div className="col-xxl-2 col-md-4  col-6">
                <div className="d-flex gap-2">
                    {/* <p className="mb-0">Firstname</p> */}
                    <span className="fs-7 text-black">Admin</span>
                   
                </div>
                {/* <span>{client?.owner_first_name}</span> */}
                <span>{client?.admin_name}</span>
            </div>
            <div className="col-xxl-2 col-md-4  col-6">
            <div className="d-flex gap-2">
            <span className="fs-7 text-black">Email</span>
               
                </div>
                <span>{client?.owner_invite_email}</span>

            </div>
            <div className="col-xxl-2 col-md-4  col-6">
                <div className="d-flex gap-2">
                <span className="fs-7 text-black">Total Members</span>
                    
                </div>
                <span>{client?.total_members>0?client?.total_members:0}</span>
            </div>
            {/* <div className="col-lg-3 col-md-5 col-sm-5 col-6">
                <div className="d-flex gap-2">
                    <p className="mb-0">Email</p>
               
                </div>
                <span>{client?.owner_invite_email}</span>
            </div> */}
            <div className="col-xxl-2 col-md-4  col-6">
                <div className="d-flex gap-2">
                    <span className="fs-7 text-black">Subscription Start Date</span>
                
                </div>
                <span>{client?.subscription_start_date?client?.subscription_start_date:"00-00-0000"}</span>
            </div>
            
            <div className="col-xxl-2 col-md-4  col-6">
            <div className="d-flex gap-2">
            <span className="fs-7 text-black">Subscription End Date</span>
                
                </div>
                <span>{client?.subscription_end_date?client?.subscription_end_date:"00-00-0000"}</span>

            </div>
      
            <div className="col-xxl-2 col-md-3 d-flex flex-column gap-2">
                <Link to={`${client?.client_id}`} className="btn btn-md rounded-pill">
                  View Profile <FaGreaterThan />
                </Link>
                <Link to={`${client?.client_id}/insights`} className="btn btn-md rounded-pill">
                  Insights <FaGreaterThan />
                </Link>
            </div>

        </div>

    </div>
</div>
  )
}

export default ClientListCard